import React, { Component } from 'react';
import { Layout, Upload } from 'antd';
// import './newHome/newHome.scss';
import './homePage.scss';
const { Content, Sider } = Layout;
import Shared from './Shared/Shared';
const { Dragger } = Upload;
import { store } from 'Store/store.index';
import { inject, observer } from 'mobx-react';
import edit from '../../assets/fw_cloud_editor/openPage/icon-pdfEdit.png';
import pdfToOffice from '../../assets/fw_cloud_editor/openPage/icon-pdfToOffice.png';
import pdfMerge from '../../assets/fw_cloud_editor/openPage/icon-pdfMerge.png';
import pdfSplit from '../../assets/fw_cloud_editor/openPage/icon-pdfSplit.png';
import pdfToImg from '../../assets/fw_cloud_editor/openPage/icon-pdfToImg.png';
import Ocr from '../../assets/fw_cloud_editor/openPage/icon-Ocr.png';
import pdfCompress from '../../assets/fw_cloud_editor/openPage/icon-pdfCompress.png';
import addOrRemovePage from '../../assets/fw_cloud_editor/openPage/icon-addOrRemovePage.png';
import imgToExcel from '../../assets/fw_cloud_editor/openPage/imgToExcel.png';
import voiceToText from '../../assets/fw_cloud_editor/openPage/voiceToText.png';
import pdfToCad from '../../assets/fw_cloud_editor/openPage/pdfToCad.png';
import removPassword from '../../assets/fw_cloud_editor/openPage/removPassword.png';
import { isMacSsoNoIos } from 'Utils/device';
import { isSafari } from 'Utils/browser-info';
import utils from '@foxit/utils';
// import {SUBSCRIBE,} from 'Components/viewer/ui/constants/user.more.constants';
@inject('appStore', 'userStore', 'accountStore', 'historyStore', 'homePageStore')
@observer
class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opening: false,
    };
  }
  doOpenFile = () => {
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      store.loginNewStore.login();
      return false;
    }
    if (this.state.opening) {
      return;
    }
    this.openFileing();
    this.props.openFile();
  };
  // 打开文件节流
  openFileing = () => {
    this.setState({
      opening: true,
    });
    setTimeout(() => {
      this.setState({
        opening: false,
      });
    }, 1000);
  };
  beforeUpload = (e) => {
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      store.loginNewStore.login();
      e.stopPropagation();
      return false;
    }
  };
  doOpenFileForDragDrop = ({ file }) => {
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      store.loginNewStore.login();
      return false;
    }
    if (file) {
      this.props.onDrop([file]);
    }
  };
  // 打开远程文档
  openUrlFileDialog = () => {
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      store.loginNewStore.login();
      return false;
    }
    store.openUrlFileStore.openURLInputDialog(true);
  };

  // 跳转开通会员
  subscriptionMember = () => {
    const hasSignIn = store.loginNewStore.isLogin;
    if (!hasSignIn) {
      store.loginNewStore.login();
      return;
    } else {
      let payOrigin = isMacSsoNoIos || isSafari ? 'edit.foxitcloud.cn/pay/edit/' : 'www.foxitcloud.cn/pay/edit/';
      let url = `https://${payOrigin}?from=startpage${location.search.trim().slice(1) && '&'}${location.search.trim().slice(1)}`;
      if (window.location.search.includes('from=pdf365/?refer=bd')) {
        url = `https://www.foxitcloud.cn/pay/edit/baidu365/${location.search.trim().slice(1) && '?'}${location.search.trim().slice(1)}`;
      }
      // TODO FOXIT 漏洞优化window.open方法；
      // window.open(url)
      const newWindow = window.open(url);
      newWindow.opener = null;
    }
  };

  handlerHot = (item) => {
    let tab = item.toolbarTab;
    if (tab === 'file-tab') {
      window.open('https://www.pdf365.cn/?agent=ybjdown');
    } else if (tab === 'pdf-to-cad-tab') {
      window.open('https://file.foxitreader.cn/file/Channel/CAD/ybjdown_FoxitCADconverterSetup.exe');
    } else if (tab === 'img-to-excel-tab') {
      window.open('https://www.pdf365.cn/img-to-excel/?agent=ybjdown');
    } else if (tab === 'voice-to-text-tab') {
      window.open('https://www.pdf365.cn/voice-to-word/?agent=ybjdown');
    } else if (tab === 'remov-password-tab') {
      window.open('https://www.pdf365.cn/pdf-unlock/?agent=ybjdown');
    } else {
      document.getElementById('fwOpenLocalFile').click();
      store.homePageStore.setOpenFileToolbarTab(tab);
    }
  };

  render() {
    const {
      // supportConvertDocumentSuffixs,
      openDocs,
      // height
    } = this.props;
    const features = [
      {
        icon: edit,
        title: 'PDF编辑',
        text: '在PDF文件中添加或编辑文本、形状、图片等内容',
        toolbarTab: 'edit-tab',
      },
      {
        icon: pdfToOffice,
        title: 'PDF转Office',
        text: '在PDF文件转换Word、excel、ppt等Office格式',
        toolbarTab: 'convert-tab',
      },
      {
        icon: pdfMerge,
        title: 'PDF合并',
        text: '将多个PDF文件合并成一个PDF文件',
        toolbarTab: 'organize-tab',
      },
      {
        icon: pdfSplit,
        title: 'PDF拆分',
        text: '将一个PDF文件拆分成多个， 支持自定义页面',
        toolbarTab: 'organize-tab',
      },
      {
        icon: pdfToImg,
        title: 'PDF转图片',
        text: '在PDF文件转换为图片格式文件',
        toolbarTab: 'convert-tab',
      },
      {
        icon: Ocr,
        title: '扫描件OCR识别',
        text: 'OCR快速识别扫描件或图片中的文字内容',
        toolbarTab: 'convert-tab',
      },
      {
        icon: pdfCompress,
        title: 'PDF压缩',
        text: '优化缩减PDF文件的大小且不牺牲文件质量',
        toolbarTab: 'file-tab',
      },
      {
        icon: addOrRemovePage,
        title: '删除/添加页面',
        text: '删除或添加PDF文件的一页或多个页面',
        toolbarTab: 'organize-tab',
      },
      {
        icon: pdfToCad,
        title: 'PDF转CAD',
        text: '将PDF文件转换成CAD文件',
        toolbarTab: 'pdf-to-cad-tab',
      },
      {
        icon: imgToExcel,
        title: '图片转Excel',
        text: '将图片中的文字内容保存成Excel文件',
        toolbarTab: 'img-to-excel-tab',
      },
      {
        icon: voiceToText,
        title: '语音转文字',
        text: '将录音/语音转换成文字，以Word样式输出',
        toolbarTab: 'voice-to-text-tab',
      },
      {
        icon: removPassword,
        title: 'PDF去密码',
        text: '去除PDF密码输入，无法打印，编辑，复制等限制',
        toolbarTab: 'remov-password-tab',
      },
    ];
    const homeSideTabList = [
      {
        tab: 'home',
        name: '主页',
      },
      {
        tab: 'share-list',
        name: '共享记录',
      },
    ];
    const homeSideTabActive = store.homePageStore.homeSideTabActive;
    const { supportConvertDocumentSuffixs, isDisabledDragFileOpen, onDrop, openFile, changeHomeSideTab } = this.props;
    return (
      <React.Fragment>
        <Layout className="fw_new-home-page">
          <Sider className="home-sider" width={220}>
            <ul>
              {homeSideTabList.map((item, index) => {
                return (
                  <li key={index} className={`${item.tab} ${item.tab === homeSideTabActive ? 'active' : ''}`} onClick={() => changeHomeSideTab(item.tab)}>
                    <i></i>
                    <span>{item.name}</span>
                  </li>
                );
              })}
            </ul>
          </Sider>
          {homeSideTabActive === 'share-list' && (
            <Layout className={`home-share-list ${homeSideTabActive === 'share-list' ? '' : 'none'}`}>
              <Shared
                parentCom="Home"
                supportConvertDocumentSuffixs={supportConvertDocumentSuffixs}
                isDisabledDragFileOpen={isDisabledDragFileOpen}
                onDrop={onDrop}
                openFile={openFile}></Shared>
            </Layout>
          )}
          <Layout className={`home-main ${homeSideTabActive === 'home' ? '' : 'none'}`}>
            <Content className="home-content-wrapper">
              {utils.util.getQueryString('agent') === 'sjmkd' && <img className="logo" src={require('../../assets/fw_cloud_editor/home/logo.png')} />}

              <h3 className="home-page-title">打开PDF</h3>
              <Dragger
                className="drop-zone-wrapper"
                // accept={`.pdf,${supportConvertDocumentSuffixs}`}
                accept={store.appStore.getSupportFileExtensions}
                customRequest={this.doOpenFileForDragDrop}
                multiple={false}
                showUploadList={false}>
                <div data-agl-cvt="6" className="fw_dragger_box" onClick={(e) => this.beforeUpload(e)}>
                  <img src={require('../../assets/fw_cloud_editor/openPage/img-dragger.png')} />
                  <p className="fw_dragger-text">拖拽PDF文件到这里</p>
                </div>
                <div
                  className="fw_more-open-method"
                  onClick={(e) => {
                    this.beforeUpload(e);
                  }}>
                  <ul
                    className="fw_more-methods-box"
                    onClick={(e) => {
                      this.beforeUpload(e);
                    }}>
                    <li
                      data-agl-cvt="6"
                      id="fwOpenLocalFile"
                      className="fw_more-methods-func"
                      onClick={(e) => {
                        this.beforeUpload(e);
                      }}>
                      <i className="fw_more-methods-func-icon fw_icon-local-file"></i>
                      <p>打开本地PDF</p>
                    </li>
                    <li
                      data-agl-cvt="6"
                      id="fwOpenDocsFile"
                      className="fw_more-methods-func"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDocs();
                      }}>
                      <i className="fw_more-methods-func-icon fw_icon-cloud-word"></i>
                      <p>从云文档打开</p>
                    </li>
                    <li
                      data-agl-cvt="6"
                      id="fwOpenUrlFile"
                      className="fw_more-methods-func openUrlFileBtn"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.openUrlFileDialog();
                      }}>
                      <i className="fw_more-methods-func-icon fw_icon-open-url-file"></i>
                      <p>从链接打开</p>
                    </li>
                  </ul>
                </div>
              </Dragger>
            </Content>
            <h3 className="home-page-title">
              热门功能{' '}
              {/* <img
                className="cursorPointer"
                src={require('../../assets/fw_cloud_editor/openPage/icon-subscriptionMember.png')}
                onClick={this.subscriptionMember}
              /> */}
            </h3>
            <div className="hot-features">
              {features.map((item, index) => {
                return (
                  <div
                    data-agl-cvt="6"
                    key={index}
                    className="hot-feature-item"
                    onClick={() => {
                      this.handlerHot(item);
                    }}>
                    <img src={item.icon} />
                    <div className="hot-feature-item-main">
                      <h4>{item.title}</h4>
                      <p>{item.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </Layout>
        </Layout>
        {homeSideTabActive === 'home' && (
          <p className="thisNumberBox home">
            ©2026 福建福昕软件开发股份有限公司 版权所有 
            <a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn">
              闽ICP备13015634号
            </a>
            ·
            <a target="_blank" rel="noopener noreferrer" href="https://myd.pdf365.cn/agreement/foxitprivacy.html">
              隐私策略
            </a>
          </p>
        )}
      </React.Fragment>
    );
  }
}
export default HomePage;
